module.exports = __webpack_public_path__ + "img/footer-text_320.2899ab7c.png";